import {FormControl, FormGroup} from '@angular/forms';
import {IpopConfiguration} from '../../../../../model/ipop-configuration.model';

export type SiteWideUnlockForm = FormGroup<{
  siteWideUnlockEnabled: FormControl<boolean>;
  bannerEnabled: FormControl<boolean>;
  unlockPopupEnabled: FormControl<boolean>;
  navigationPopupEnabled: FormControl<boolean>;
  unlockDesktop: FormControl<number | null>;
  navigationDesktop: FormControl<number | null>;
}>;

/** Disabled controls retain selections; untouched settings are omitted on unrelated saves. */
export function siteWideUnlockPayload(form: SiteWideUnlockForm | null | undefined): Partial<IpopConfiguration>
{
  let payload: Partial<IpopConfiguration> = {};
  if (form?.dirty && form.enabled && form.valid) {
    const values = form.getRawValue();
    payload = {
      siteWideUnlockEnabled: values.siteWideUnlockEnabled
    };
    // A master-off save preserves stored preferences, including migrated rows without layouts.
    if (values.siteWideUnlockEnabled) {
      payload.widgetSettings = [
        {widgetType: 'site_wide_unlock_banner', enabled: values.bannerEnabled, positionLayoutId: null},
        {widgetType: 'site_wide_unlock_popup', enabled: values.unlockPopupEnabled, positionLayoutId: values.unlockDesktop},
        {widgetType: 'site_wide_unlock_navigation', enabled: values.navigationPopupEnabled, positionLayoutId: values.navigationDesktop}
      ];
    }
  }

  return payload;
}
